import React from 'react';
import { Pencil, KeyRound, Trash2 } from 'lucide-react';
import './UsersTable.css';

export default function UsersTable({ users, loading, error, onEdit, onResetPwd, onDelete }) {
  if (loading) {
    return (
      <div className="users-table-wrapper">
        <div className="users-table-state">Carregando...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="users-table-wrapper">
        <div className="users-table-state users-table-state-error">{error}</div>
      </div>
    );
  }

  if (!users || users.length === 0) {
    return (
      <div className="users-table-wrapper">
        <div className="users-table-state">Nenhum usuário encontrado.</div>
      </div>
    );
  }

  return (
    <div className="users-table-wrapper">
      <table className="users-table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Usuário</th>
            <th>E-mail</th>
            <th>Condomínio</th>
            <th>Role</th>
            <th className="users-table-actions-col">Ações</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id}>
              <td className="cell-main" title={u.name || ''}>{u.name}</td>
              <td title={u.user || ''}>{u.user}</td>
              <td title={u.email || ''}>{u.email}</td>
              <td title={u.condominio || ''}>{u.condominio}</td>
              <td>
                {u.role ? (
                  <span className="role-pill">
                    {u.role}
                  </span>
                ) : (
                  <span className="role-pill role-pill-muted">Sem role</span>
                )}
              </td>
              <td className="users-table-actions-col">
                <div className="users-table-actions">
                  <button
                    type="button"
                    className="btn-icon btn-icon-edit"
                    onClick={() => onEdit(u)}
                    title="Editar usuário"
                  >
                    <Pencil size={16} />
                    <span>Editar</span>
                  </button>

                  <button
                    type="button"
                    className="btn-icon btn-icon-password"
                    onClick={() => onResetPwd(u)}
                    title="Resetar senha"
                  >
                    <KeyRound size={16} />
                    <span>Senha</span>
                  </button>

                  <button
                    type="button"
                    className="btn-icon btn-icon-danger"
                    onClick={() => onDelete(u)}
                    title="Excluir usuário"
                  >
                    <Trash2 size={16} />
                    <span>Excluir</span>
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}